export interface BaseLegalPendenteJson {
  BaseLegal: number;
  Exercicio: number;
}

export class BaseLegalPendente {
  IdBaseLegal: number;
  Nome?: string;
  Exercicio: number;

  constructor(obj?: BaseLegalPendenteJson) {
    if (obj) {
      this.IdBaseLegal = obj.BaseLegal;
      this.Exercicio = obj.Exercicio;
    }
  }
}
